export const DEMO_STUDIO_ROLES = ['admin', 'super_admin', 'marketing'];

/** Build-time flag — set REACT_APP_ENABLE_DEMO_STUDIO=true to expose /studio/demo. */
export function isDemoStudioEnabled() {
  const raw = (process.env.REACT_APP_ENABLE_DEMO_STUDIO || '').trim().toLowerCase();
  return raw === 'true' || raw === '1' || raw === 'yes';
}

export function canAccessDemoStudio(role) {
  return DEMO_STUDIO_ROLES.includes((role || '').toLowerCase());
}

/** Role + feature flag — use for nav and route guards. */
export function canUseDemoStudio(role) {
  return isDemoStudioEnabled() && canAccessDemoStudio(role);
}
